export const VestingBulkUploadGridConfig = {
	list: "Vesting",
	grid: {
		gridId: 'vestingBulkUploadGrid',
		height: 500,
		checkbox: false,
		edit: false,
		delete: true,
		document: false,
		groupable: true,
		actionsColumnWidth: 80
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		Status: {
			class: 'choice',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: true
		},
		Validation: {
			dataName: 'Validation',
			type: 'string',
			title: 'Validation',
			width: 130,
			hidden: false,
			readOnly: true
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 100,
			hidden: true
		},
		ProgramID: {
			class: 'lookup',
			dataName: 'Program/ProgramID',
			type: 'string',
			title: 'Program ID',
			width: 200,
			hidden: false,
			readOnly: true
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program',
			width: 200,
			hidden: false,
			readOnly: true
		},
		ReceiverId: {
			class: 'lookup',
			dataName: 'ReceiverId',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: true
		},
		PartnerID: {
			class: 'lookup',
			dataName: 'Receiver/PartnerID',
			type: 'number',
			title: 'Partner ID',
			width: 150,
			hidden: false,
			readOnly: true
		},
		ReceiverFullName: {
			class: 'lookup',
			dataName: 'Receiver/FullName',
			type: 'string',
			title: 'Partner',
			width: 180,
			hidden: false,
			readOnly: true
		},

		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 150,
			hidden: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 150,
			hidden: false
		},
		VestingType: {
			class: 'choice',
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 150,
			hidden: false
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'UnitPool',
			width: 150,
			hidden: false
		},
		Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'number',
			title: 'Vesting Base Units',
			width: 120,
			hidden: true,
			template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", Unit )#</span>'
		},
		VestStartDate: {
			class: 'value',
			dataName: 'VestStartDate',
			type: 'date',
			title: 'Vesting Start Date',
			filterable: true,
			width: 220,
			hidden: true
		},
		Year: {
			class: 'value',
			dataName: 'Year',
			type: 'number',
			title: 'Vesting Year',
			filterable: true,
			width: 180,
			hidden: true
		},
		VestedDate: {
			class: 'value',
			dataName: 'VestedDate',
			type: 'date',
			title: 'Vesting Date',
			filterable: true,
			width: 180,
			hidden: false
		},
		Percentage: {
			class: 'value',
			dataName: 'Percentage',
			type: 'percent',
			format: "{0:p}",
			title: 'Vesting Percentage',
			template: '<span class="number-cell-ui">#=kendo.toString(Percentage, "p1")#</span>',
			filterable: true,
			width: 180,
			hidden: false
		},
		VestedUnit: {
			class: 'value',
			dataName: 'VestedUnit',
			type: 'number',
			title: 'Vesting Units',
			filterable: true,
			template: '<span class="number-cell-ui">#=kendo.toString(VestedUnit)#</span>',
			width: 180,
			hidden: false
		},
		SpecialArrangement: {
			class: 'value',
			dataName: 'SpecialArrangement',
			type: 'string',
			title: 'Special Vesting',
			filterable: true,
			width: 180,
			hidden: false
		},
		TransactionDate: {
			class: 'value',
			dataName: 'TransactionDate',
			type: 'date',
			title: 'Date',
			filterable: true,
			width: 100,
			hidden: true
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true
		},
		BatchGUID: {
			class: 'value',
			dataName: 'BatchGUID',
			type: 'string',
			title: 'Batch Id',
			width: 100,
			hidden: true
		}
	}
}